<template>
    <div id="pwa-intervention-devices" class="mx-2">
        <button-go-back text="Détails intervention"></button-go-back>

	    <div class="md-layout md-gutter">
		    <div class="md-layout-item md-size-100">
			    <div class="intervention-details__card">
				    <p class="font-medium mb-2 text-sm">Liste des dispositifs</p>
				    <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
				    <div>
					    <form @submit.prevent="checkSearchNumber">
						    <div class="flex items-center justify-between space-x-5 mb-1">
							    <md-field class="md-invalid">
								    <label>Numéro</label>
								    <md-input v-model="search" name="number" type="number"></md-input>
								    <validation-error :errors="apiValidationErrors.search" />
							    </md-field>
							    <md-button class="md-icon-button md-raised my-0 md-success" type="submit">
								    <font-awesome-icon class="md-icon" :icon="['fa', 'search']" />
							    </md-button>
						    </div>
					    </form>
				    </div>
			    </div>
		    </div>
	    </div>
	    <div class="tabs-layout">
		    <md-tabs @md-changed="changeTab" md-active-tab="tab-not-checked">
			    <md-tab id="tab-not-checked" md-label="Non Saisis">
				    <template v-if="tabs[0].active">
					    <p class="font-medium mb-2 text-base">Liés à l'intervention ({{ notCheckedDevices.sameInterventionType.length }})</p>
					    <div class="devices-grid" v-if="notCheckedDevices.sameInterventionType.length > 0">
						    <device-card v-for="device in notCheckedDevices.sameInterventionType" :key="device.id"
						                 :id="device.id"
						                 :number="device.number"
						                 :location="device.location"
						                 :deviceTypeId="device.device_type_id"
						                 :isSameInterventionType="true">
						    </device-card>
					    </div>
					    <span v-else class="text-sm">Aucun dispositif restant.</span>
					    <template v-if="notCheckedDevices.notSameInterventionType.length > 0">
						    <md-divider class="mt-3.5 mb-2"></md-divider>
						    <p class="font-medium mb-2 text-base">Présents sur le site ({{ notCheckedDevices.notSameInterventionType.length }})</p>
						    <div class="devices-grid" v-if="notCheckedDevices.notSameInterventionType">
							    <device-card v-for="device in notCheckedDevices.notSameInterventionType" :key="device.id"
							                 :id="device.id"
							                 :number="device.number"
							                 :location="device.location"
							                 :deviceTypeId="device.device_type_id"
							                 :isSameInterventionType="false">
							    </device-card>
						    </div>
						    <span v-else class="text-sm">Aucun dispositif restant.</span>
					    </template>
				    </template>
			    </md-tab>
			    <md-tab id="tab-checked" md-label="Saisis">
				    <template v-if="tabs[1].active">
					    <p class="font-medium mb-2 text-base">Liés à l'intervention ({{ checkedDevices.sameInterventionType.length }})</p>
					    <div class="devices-grid" v-if="checkedDevices.sameInterventionType.length > 0">
						    <device-card v-for="device in checkedDevices.sameInterventionType" :key="device.id"
						                 checked
						                 :id="device.id"
						                 :number="device.number"
						                 :location="device.location"
						                 :deviceTypeId="device.device_type_id"
						                 :isSameInterventionType="true"
						                 :reportId="device.reports[0].id"
						                 @deleted="deleteDeviceReport">
						    </device-card>
					    </div>
					    <span v-else class="text-sm">Aucun dispositif saisi.</span>
					    <template v-if="checkedDevices.notSameInterventionType.length > 0">
						    <md-divider class="mt-3.5 mb-2"></md-divider>
						    <p class="font-medium mb-2 text-base">Présents sur le site ({{ checkedDevices.notSameInterventionType.length }})</p>
						    <div class="devices-grid" v-if="checkedDevices.notSameInterventionType.length > 0">
							    <device-card v-for="device in checkedDevices.notSameInterventionType" :key="device.id"
							                 checked
							                 :id="device.id"
							                 :number="device.number"
							                 :location="device.location"
							                 :deviceTypeId="device.device_type_id"
							                 :isSameInterventionType="false"
							                 :reportId="device.reports[0].id"
							                 @deleted="deleteDeviceReport">
							    </device-card>
						    </div>
						    <span v-else class="text-sm">Aucun dispositif saisi.</span>
					    </template>
				    </template>
			    </md-tab>
		    </md-tabs>
	    </div>

        <div class="calendar-overlay opacity-100 fixed z-50 w-full h-full" v-if="updating">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonGoBack from "@/pages/ProgressiveWebApp/components/ButtonGoBack";
import DeviceCard from "@/pages/ProgressiveWebApp/Planning/devices/components/DeviceCard";

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

export default {
    name: "PwaInterventionDevices",
    components: { ButtonGoBack, DeviceCard, ValidationError },
    mixins: [formMixin, indexedDBMixin],
    data() {
        return {
            search: null,
            checkedDevices: {
                sameInterventionType: [],
                notSameInterventionType: [],
	            loaded: false
            },
            notCheckedDevices: {
                sameInterventionType: [],
                notSameInterventionType: [],
	            loaded: false
            },
            tabs: [
                { id: 'tab-not-checked', active: true },
                { id: 'tab-checked', active: false },
            ],
            updating: true
        }
    },
    methods: {
        async getInterventionDevices() {
	        // "devices" contient uniquement une liste d'id
	        const devices = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/devices`)
	        // "site" contient tous les dispositifs avec leurs détails
	        const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/site`)

	        // il faut associer l'id de chaque "devices" avec celui dans l'array "devices" dans "site"

	        if(this.tabs[0].active && !this.notCheckedDevices.loaded) {
		        devices.value.notChecked.sameInterventionType.map(deviceId => {
			        this.notCheckedDevices.sameInterventionType.push(site.value.devices.find(device => device.id === deviceId))
		        })

		        devices.value.notChecked.notSameInterventionType.map(deviceId => {
			        this.notCheckedDevices.notSameInterventionType.push(site.value.devices.find(device => device.id === deviceId))
		        })

		        this.notCheckedDevices.sameInterventionType.sort(this.sortDevices)
		        this.notCheckedDevices.notSameInterventionType.sort(this.sortDevices)
		        this.notCheckedDevices.loaded = true
	        } else if(this.tabs[1].active && !this.checkedDevices.loaded) {
		        devices.value.checked.sameInterventionType.map(deviceId => {
			        this.checkedDevices.sameInterventionType.push(site.value.devices.find(device => device.id === deviceId))
		        })

		        devices.value.checked.notSameInterventionType.map(deviceId => {
			        this.checkedDevices.notSameInterventionType.push(site.value.devices.find(device => device.id === deviceId))
		        })

		        this.checkedDevices.sameInterventionType.sort(this.sortDevices)
		        this.checkedDevices.notSameInterventionType.sort(this.sortDevices)
		        this.checkedDevices.loaded = true
	        }

            this.updating = false
        },
	    deleteDeviceReport({ deviceId, isSameInterventionType }) {
			const type = isSameInterventionType ? 'sameInterventionType' : 'notSameInterventionType'

		    const index = this.checkedDevices[type].findIndex(device => device.id === deviceId)
		    const device = this.checkedDevices[type].splice(index, 1)[0]
		    this.notCheckedDevices[type].push(device)

		    this.notCheckedDevices[type].sort(this.sortDevices)
		    this.checkedDevices[type].sort(this.sortDevices)
	    },
	    sortDevices(a, b) {
		    if (a.number < b.number) {
			    return -1;
		    }
		    if (a.number > b.number) {
			    return 1;
		    }
		    return 0;
	    },
        checkSearchNumber() {
            this.resetApiValidation()
            const search = parseInt(this.search)
            const inChecked = this.checkedDevices.sameInterventionType.find(device => device.number === search) || this.checkedDevices.notSameInterventionType.find(device => device.number === search)
            const inNotChecked = this.notCheckedDevices.sameInterventionType.find(device => device.number === search) || this.notCheckedDevices.notSameInterventionType.find(device => device.number === search)
            if(inNotChecked) {
                this.goToRoute('Pwa Intervention Device Report', { deviceId: inNotChecked.id })
            } else if(inChecked) {
                this.setApiValidation([{
                    source: { pointer: '/data/attributes/search' },
                    detail: `Dispositif numéro ${search} est déjà saisi`
                }])
            } else {
                this.setApiValidation([{
                    source: { pointer: '/data/attributes/search' },
                    detail: `Dispositif numéro ${search} est indisponible`
                }])
            }
        },
        goToRoute(route, params = {}) {
            this.$router.push({ name: route, params })
        },
        changeTab(id = 'tab-not-checked') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            activeTab.active = true

	        this.getInterventionDevices()
        },
    },
    mounted() {
        this.getInterventionDevices()
    },
    watch: {
        search() {
            this.resetApiValidation()
        }
    }
}
</script>

<style scoped>

</style>
